<template>
  <TableGradient
      icon-name="cubes"
      :title="$t('tuevs.component.listagem.titulo_pagina')"
      :text-empty="$t('tuevs.component.listagem.table.empty')"
      table-data
      route-new="tuevs.component.create"
      :text-new="$t('tuevs.component.listagem.novo')"
      :fields="fields"
      :items="components"
      :loading="isLoading"
      :paginator="pagination"
      @list="evt => $store.dispatch('tuevs/component/listAll', evt)">
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
          <em v-if="linha.item.status">{{ $t('tuevs.component.listagem.habilitado') }}</em>
          <em v-else>{{ $t('tuevs.component.listagem.desabilitado') }}</em>
      </span>
    </template>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index" :to="{ name: 'tuevs.component.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('tuevs.component.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'tuevs/component/isLoading',
      components: 'tuevs/component/all',
      pagination: 'tuevs/component/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('tuevs.component.listagem.table.nome'), sortable: true},
        {key: 'code', label: this.$t('tuevs.component.listagem.table.codigo'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('tuevs.component.listagem.table.editar')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'tuevs/component/listAll'
    ])
  },
  mounted() {
    this['tuevs/component/listAll'](this.pagination)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
